import { render, staticRenderFns } from "./FbaBarcode.vue?vue&type=template&id=d5945fae&scoped=true&"
import script from "./FbaBarcode.vue?vue&type=script&lang=js&"
export * from "./FbaBarcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5945fae",
  null
  
)

export default component.exports